import { useState } from 'react';
import { ChatEngine } from "react-chat-engine";
import ChatFeed from './components/ChatFeed';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import './App.css';

const projectID = '5700f478-fcb0-43db-b448-c44e124b1a5b';

const App = () => {

  const [appState, setAppState] = useState('LoginForm');
  const shiftToRegister = () => setAppState("RegisterForm");
  const shiftToLogin = () => setAppState("LoginForm");
  const shiftToAlreadyLogedIn = () => setAppState("alreadyLogedIn");
  const signOut = () => {
    setAppState("LoginForm");
    localStorage.setItem('username', "");
    localStorage.setItem('password', "");
    window.location.reload();
  };

  if (!localStorage.getItem('username') && (appState === "LoginForm")) return <LoginForm appState={appState} shift={shiftToRegister} logedIn={shiftToAlreadyLogedIn} />;
  if (!localStorage.getItem('username') && (appState === "RegisterForm")) return <RegisterForm appState={appState} shift={shiftToLogin} logedIn={shiftToAlreadyLogedIn} />;

  return (
    <>
      {/* <div>Hi</div> */}
      {/* <div className="marginTP"> */}
      <ChatEngine
        height="100vh"
        projectID={projectID}
        userName={localStorage.getItem('username')}
        userSecret={localStorage.getItem('password')}
        renderChatFeed={(chatAppProps) => <ChatFeed {...chatAppProps} signOut={signOut} />}
        onNewMessage={() => new Audio('https://chat-engine-assets.s3.amazonaws.com/click.mp3').play()}
      />
      {/* </div> */}
    </>
  );

};

export default App;
